import { API_PREFIX } from '../consts';
import { GET } from '../utils/request';

export function queryMixpanelLogToggle() {
  return GET(`${API_PREFIX}/v1/config/feature/mixpanel_pos_dashboard_log`, {});
}
